import { GetMoreQuestionForCustomMeta, GetMoreQuestionForCustomPayload } from 'types/store/GetMoreQuestionForCustom';
import { createAsyncReducer } from 'utils/Redux';

import { getMoreQuestionForCustomActions } from '../actions';

export default createAsyncReducer<GetMoreQuestionForCustomMeta, GetMoreQuestionForCustomPayload>(getMoreQuestionForCustomActions);
